<template>
  <gg-modal :is-active="outdatedCacheModal">
    <template v-slot:title>
      Page Outdated
    </template>
    <template v-slot:body>
      Your cache is outdated. Please refresh this page to clear your cache.

      This dialog will go away once your local cache is cleared and updated.
    </template>
  </gg-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClearCacheModal',
  computed: {
    ...mapGetters(['outdatedCacheModal']),
  },
}
</script>
